<template>
  <div class="scrrolMidTable position-relative latestNewsArticle">
    <alert-notification v-if="notification_msg != ''" />
    <div class="mid_scroll_content mt-0">
      <section class="depoist_fund mktSearch pb-0 border-0 p-3 max-1440">
        <div class="row justify-content-center">
          <div class="col-12 mb-4 mt-xl-4">
            <div
              class="d-flex align-items-center justify-content-between flex-wrap mb-4"
            >
              <div class="categeroies">
                <h3 class="semibold mb-1">Categories</h3>
                <p>Find out which crypto gained the most value</p>
              </div>
              <a
                v-if="tabOpened == 'marketfeed'"
                @click="() => openScreener()"
                href="javascript:void(0)"
                class="link f-14 d-flex align-items-center"
                >View More <feather size="20px" type="arrow-right"></feather
              ></a>
            </div>
            <div class="row coinCarousel">
              <div v-for="isin in top_categories" class="col1 px-3">
                <div class="card-body text-start">
                  <div class="d-flex align-items-center">
                    <span class="flex-shrink-0 l-1">
                      <img
                        width="40"
                        :src="
                          '../../../../static/website/images/crypto_logos/' +
                          getCurrencyName(isin.i, true).toLowerCase() +
                          '.png'
                        "
                        alt="Icon"
                      />
                    </span>
                    <div class="flex-grow-1 ml-2 l-1 text-start">
                      <p class="mb-0 d-flex themecolor uppercase semibold">
                        {{ getCurrencyName(isin.i, true) }}
                        <span class="cripto ml-3 f-10">{{
                          getCurrencyName(isin.i)
                        }}</span>
                      </p>
                      <span
                        class="f-10 hTrade greenBG"
                        v-if="
                          'topGainer' in isin.other && isin.other.topGainer == 1
                        "
                        >Top Gainer</span
                      >
                      <span
                        class="f-10 hTrade redBG"
                        v-if="
                          'topLooser' in isin.other && isin.other.topLooser == 1
                        "
                        >Top Looser</span
                      >
                      <span
                        class="f-10 hTrade themeBG text-white"
                        v-if="
                          'higestVolume' in isin.other &&
                          isin.other.higestVolume == 1
                        "
                        >Higest Volume</span
                      >
                    </div>
                  </div>
                  <h6 class="medium mt-2">{{ formatPrice(isin.A, true) }}</h6>
                  <div
                    class="d-flex align-items-center justify-content-between l-1"
                  >
                    <div class="ltr">
                      <span class="f-12" :class="isin.CB > 0 ? 'green' : 'red'"
                        >{{ formatPrice(isin.CB) }}%</span
                      >
                      <span class="f-10 d-block mt-2">24h Changes</span>
                    </div>
                    <div class="rtr">
                      <span class="f-12 medium themecolor">{{
                        isin.VOLUME ? "$" + formatPrice(isin.VOLUME) : "-"
                      }}</span>
                      <span class="f-10 d-block mt-2">24h Volume</span>
                    </div>
                  </div>
                  <div class="footerGraph">
                    <img
                      src="../../../../static/website/images/graph-1.svg"
                      alt="Graph"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            id="tabs"
            class="col-12 customSlice-tabs text-center my-md-5 my-4"
          >
            <ul
              class="d-inline-flex align-items-center justify-content-center tabsList"
            >
              <li>
                <a
                  @click.prevent="tabOpened = 'marketfeed'"
                  :class="tabOpened == 'marketfeed' ? 'active' : ''"
                  class="cp-tabs semibold"
                  href="javascript:void(0)"
                >
                  Market Feeds</a
                >
              </li>
              <li>
                <a
                  @click.prevent="
                    tabOpened = 'screener';
                    categoryFlag = 0;
                  "
                  :class="tabOpened == 'screener' ? 'active' : ''"
                  class="cp-tabs semibold"
                  href="javascript:void(0)"
                  >Screener</a
                >
              </li>
              <li>
                <a
                  @click.prevent="tabOpened = 'updates'"
                  :class="tabOpened == 'updates' ? 'active' : ''"
                  class="cp-tabs semibold"
                  href="javascript:void(0)"
                  >Latest Updates</a
                >
              </li>
            </ul>
          </div>
          <div class="col-12" v-show="tabOpened == 'marketfeed'">
            <div class="border position-relative border-radius-15">
              <div
                class="select_cur_filter d-flex align-items-center justify-content-between border-bottom p-3"
              >
                <div
                  class="forMobile-toggle d-none"
                  :class="mobtoggleButton ? 'active' : ' '"
                >
                  <a
                    @click.prevent="mobtoggleButton = !mobtoggleButton"
                    href="#"
                    class="d-flex align-items-center justify-content-between"
                  >
                    {{ filterType }}
                    <feather
                      size="16px"
                      type="chevron-down"
                      class="mobDrop"
                    ></feather>
                  </a>
                </div>
                <ul
                  :class="mobtoggleButton ? 'active' : ' '"
                  class="border-0 opendropdownMenu-mob nav nav-tabs noBG"
                >
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      :class="filterType == 'ALL' ? 'active' : ''"
                      @click="changeFilter('ALL')"
                      >All Markets</a
                    >
                  </li>
                  <li class="nav-item">
                    <a
                      class="nav-link d-flex align-items-center"
                      :class="filterType == 'Favorites' ? 'active' : ''"
                      @click="changeFilter('Favorites')"
                    >
                      <feather size="16px" class="mr-2" type="star"></feather>
                      Favorites
                    </a>
                  </li>
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      :class="filterType == 'BTC' ? 'active' : ''"
                      @click="changeFilter('BTC')"
                      >BTC</a
                    >
                  </li>
                  <!-- <li class="nav-item"><a class="nav-link" :class="(filterType == 'LTC')?'active':''" @click="filterType = 'LTC';filterCrypto = '';page='1'">LTC</a></li> -->
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      :class="filterType == 'ETH' ? 'active' : ''"
                      @click="changeFilter('ETH')"
                      >ETH</a
                    >
                  </li>
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      :class="filterType == 'USDT' ? 'active' : ''"
                      @click="changeFilter('USDT')"
                      ><p v-if="$env_var.restricted_currencies.hasOwnProperty('USDT')" class="mb-0">{{$env_var.restricted_currencies['USDT'].currency_name}}</p></a
                    >
                  </li>
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      :class="filterType == 'USD' ? 'active' : ''"
                      @click="changeFilter('USD')"
                      >USD</a
                    >
                  </li>
                </ul>
                <div
                  class="form-group position-relative includeIco searchTable mb-0"
                >
                  <input
                    type="text"
                    placeholder="Search all Cryptos"
                    class="form-control"
                    name="legal_name"
                    v-model="filterCrypto"
                    v-validate="'required'"
                    @keyup="
                      filterType = 'ALL';
                      page = '1';
                    "
                  />
                  <span class="searchIco"
                    ><feather type="search"></feather
                  ></span>
                </div>
              </div>
              <div class="marketData table-responsive">
                <table class="table table-striped table-bordered" width="100%">
                  <thead>
                    <tr>
                      <th>Market</th>
                      <th>Last Price</th>
                      <th>Est.USD Value</th>
                      <th>24h High</th>
                      <th>24h Low</th>
                      <th>24h Volume</th>
                      <th>24h Change</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody
                    v-if="
                      get_currencies &&
                      Object.keys(get_currencies).length > 0 &&
                      filterType == 'ALL' &&
                      filterCrypto == ''
                    "
                  >
                    <tr
                      v-for="(spreads, key, index) in get_currencies"
                      v-if="
                        index >= (page - 1) * pageLimit &&
                        index < page * pageLimit
                      "
                    >
                      <td>
                        <span class="d-flex align-items-center">
                          <a
                            href="#"
                            :class="
                              fev_list.includes(spreads.other.isinid)
                                ? 'active'
                                : ''
                            "
                          >
                            <feather
                              size="16px"
                              class="mr-3"
                              type="star"
                              @click.prevent="
                                addRemoveFev(spreads.other.isinid)
                              "
                            ></feather>
                          </a>
                          <span class="inTableIcon ml-0">
                            <img
                              :src="
                                '../../../../static/website/images/crypto_logos/' +
                                spreads.other.isinid
                                  .split('-')[0]
                                  .toLowerCase() +
                                '.png'
                              "
                              @error="handleImgErr($event)"
                              v-if="
                                isImage(
                                  spreads.other.isinid
                                    .split('-')[0]
                                    .toLowerCase()
                                )
                              "
                            />
                            <span class="firstName" v-else>{{
                              spreads.other.isinid.split("-")[0].charAt(0)
                            }}</span>
                          </span>
                          <!-- <i v-bind:class="[{'caret-up': spreads.buy_increase_staus}, {'caret-down': !spreads.buy_increase_staus}]"></i> -->
                          <div class="iqlName">
                            {{ spreads.other.isinid }}
                            <span class="inbtmSpreds">{{
                              spreads.other.Description
                            }}</span>
                          </div>
                        </span>
                      </td>
                      <td
                        v-bind:class="[
                          { green: spreads.buy_increase_staus },
                          { red: !spreads.buy_increase_staus },
                        ]"
                      >
                        {{ formatPrice(spreads.A, true) }}
                      </td>
                      <!-- NOTE: Add "red" to class for Red font and "green" for Green font if Black just leave it blank -->
                      <td>${{ formatPrice(spreads.priceInUsd) }}</td>

                      <td>
                        {{ formatPrice(spreads.ohlcData.high, true) }}
                        {{ spreads.other.isinid.split("-")[1] }}
                      </td>

                      <td>
                        {{ formatPrice(spreads.ohlcData.low, true) }}
                        {{ spreads.other.isinid.split("-")[1] }}
                      </td>

                      <td>${{ formatPrice(spreads.VOLUME) }}</td>
                      <td>
                        <span
                          class="d-flex align-items-center"
                          :class="[
                            { green: formatfloat(spreads.CB) > 0 },
                            { red: formatfloat(spreads.CB) < 0 },
                          ]"
                        >
                          <i
                            v-bind:class="[
                              { 'caret-up': formatfloat(spreads.CB) > 0 },
                              { 'caret-down': formatfloat(spreads.CB) < 0 },
                            ]"
                          ></i>
                          {{ formatPrice(spreads.CB) }}%
                        </span>
                      </td>
                      <td>
                        <a
                          class="cap_btn blue withdrawlBtn"
                          href="#"
                          @click.prevent="exchngeNowFunc(spreads.other.isinid)"
                          v-if="
                            ExchangeEnableDisable(spreads.other.isinid) &&
                            parseInt(spreads.other.Spread) == 1
                          "
                          >Exchange Now</a
                        >
                        <p v-else>Non-tradable</p>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else-if="dataList(get_currencies).length > 0">
                    <tr
                      v-for="(spreads, index) in dataList(get_currencies)"
                      v-if="
                        index >= (page - 1) * pageLimit &&
                        index < page * pageLimit
                      "
                    >
                      <td>
                        <span class="d-flex align-items-center">
                          <a
                            href="#"
                            :class="
                              fev_list.includes(spreads.other.isinid)
                                ? 'active'
                                : ''
                            "
                          >
                            <feather
                              size="16px"
                              class="mr-3"
                              type="star"
                              @click.prevent="
                                addRemoveFev(spreads.other.isinid)
                              "
                            ></feather>
                          </a>
                          <span class="inTableIcon ml-0">
                            <img
                              :src="
                                '../../../../static/website/images/crypto_logos/' +
                                spreads.other.isinid
                                  .split('-')[0]
                                  .toLowerCase() +
                                '.png'
                              "
                              @error="handleImgErr($event)"
                              v-if="
                                isImage(
                                  spreads.other.isinid
                                    .split('-')[0]
                                    .toLowerCase()
                                )
                              "
                            />
                            <span class="firstName" v-else>{{
                              spreads.other.isinid.split("-")[0].charAt(0)
                            }}</span>
                          </span>
                          <!-- <i v-bind:class="[{'caret-up': spreads.buy_increase_staus}, {'caret-down': !spreads.buy_increase_staus}]"></i> -->
                          <div class="iqlName">
                            {{ spreads.other.isinid
                            }}<span class="inbtmSpreds">{{
                              spreads.other.Description
                            }}</span>
                          </div>
                        </span>
                      </td>
                      <td
                        v-bind:class="[
                          { green: spreads.buy_increase_staus },
                          { red: !spreads.buy_increase_staus },
                        ]"
                      >
                        {{ formatPrice(spreads.A, true) }}
                      </td>
                      <!-- NOTE: Add "red" to class for Red font and "green" for Green font if Black just leave it blank -->
                      <!-- <td v-bind:class="[{'green': spreads.sell_increase_staus}, {'red': !spreads.sell_increase_staus}]">{{formatfloat(spreads.A)}}</td> -->
                      <td>${{ formatPrice(spreads.priceInUsd) }}</td>
                      <td>
                        {{ formatPrice(spreads.ohlcData.high, true) }}
                        {{ spreads.other.isinid.split("-")[1] }}
                      </td>
                      <td>
                        {{ formatPrice(spreads.ohlcData.low, true) }}
                        {{ spreads.other.isinid.split("-")[1] }}
                      </td>
                      <td>${{ formatPrice(spreads.VOLUME) }}</td>
                      <td>
                        <span
                          class="d-flex align-items-center"
                          :class="[
                            { green: formatfloat(spreads.CB) > 0 },
                            { red: formatfloat(spreads.CB) < 0 },
                          ]"
                        >
                          <i
                            v-bind:class="[
                              { 'caret-up': formatfloat(spreads.CB) > 0 },
                              { 'caret-down': formatfloat(spreads.CB) < 0 },
                            ]"
                          ></i>
                          {{ formatPrice(spreads.CB) }}%
                        </span>
                      </td>
                      <td>
                        <a
                          class="cap_btn blue withdrawlBtn"
                          href="#"
                          @click.prevent="exchngeNowFunc(spreads.other.isinid)"
                          v-if="
                            ExchangeEnableDisable(spreads.other.isinid) &&
                            parseInt(spreads.other.Spread) == 1
                          "
                          >Exchange Now</a
                        >
                        <p v-else>Non-tradable</p>
                      </td>
                    </tr>
                  </tbody>
                  <table-loader
                    :pageloader_value="pageLoader"
                    :type="'table'"
                    :colspan="'8'"
                    :listLength="dataList(get_currencies).length"
                    v-else
                  ></table-loader>
                </table>
              </div>
              <pagination
                :totalRecords="Object.keys(get_currencies).length"
                :limit="pageLimit"
                :pageNo="page"
                v-if="
                  Object.keys(get_currencies).length > 0 &&
                  !pageLoader &&
                  filterType == 'ALL' &&
                  filterCrypto == ''
                "
                >2</pagination
              >
              <pagination
                :totalRecords="dataList(get_currencies).length"
                :limit="pageLimit"
                :pageNo="page"
                v-else-if="dataList(get_currencies).length > 0 && !pageLoader"
                >1</pagination
              >
            </div>
          </div>
          <div class="col-12" v-show="tabOpened == 'screener'">
            <div class="container" v-if="!categoryFlag">
              <div class="row CryptoMarketScreener">
                <div class="col-12 text-center">
                  <h4 class="mb-5 semibold">Crypto Market Screener</h4>
                </div>
                <div class="col-12 col-md-4" @click="categoryFlag = 1">
                  <a
                    href="javascript:void(0)"
                    class="card-body d-flex align-items-center"
                  >
                    <span class="flex-shrink-0 rounded-circle">
                      <img
                        src="../../../../static/website/images/market-screener1.svg"
                        alt="Icon"
                        title="Top Gainer"
                      />
                    </span>
                    <h5 class="mb-0 ml-4">Top Gainers</h5>
                  </a>
                </div>

                <div class="col-12 col-md-4" @click="categoryFlag = 4">
                  <a
                    href="javascript:void(0)"
                    class="card-body d-flex align-items-center"
                  >
                    <span class="flex-shrink-0 rounded-circle">
                      <img
                        src="../../../../static/website/images/market-screener4.svg"
                        alt="Icon"
                        title="Hot Trending"
                      />
                    </span>
                    <h5 class="mb-0 ml-4">Hot Trending</h5>
                  </a>
                </div>
                <div class="col-12 col-md-4" @click="categoryFlag = 3">
                  <a
                    href="javascript:void(0)"
                    class="card-body d-flex align-items-center"
                  >
                    <span class="flex-shrink-0 rounded-circle"
                      ><img
                        src="../../../../static/website/images/market-screener5.svg"
                        alt="Icon"
                        title="Highest Volume"
                      />
                    </span>
                    <h5 class="mb-0 ml-4">Highest Volume</h5>
                  </a>
                </div>
                <div class="col-12 col-md-4" @click="categoryFlag = 2">
                  <a
                    href="javascript:void(0)"
                    class="card-body d-flex align-items-center"
                  >
                    <span class="flex-shrink-0 rounded-circle"
                      ><img
                        src="../../../../static/website/images/market-screener6.svg"
                        alt="Icon"
                        title="Top Losers"
                      />
                    </span>
                    <h5 class="mb-0 ml-4">Top Losers</h5>
                  </a>
                </div>
              </div>
            </div>
            <div class="container-fluid" v-else>
              <div class="row CryptoMarketScreener">
                <div
                  class="col-12 text-center d-flex align-items-center justify-content-between mb-4"
                >
                  <h4 class="semibold mr-3" v-if="categoryFlag == 1">
                    Top Gainer
                  </h4>
                  <h4 class="semibold mr-3" v-if="categoryFlag == 2">
                    Top Looser
                  </h4>
                  <h4 class="semibold mr-3" v-if="categoryFlag == 3">
                    Most Traded
                  </h4>
                  <h4 class="semibold mr-3" v-if="categoryFlag == 4">
                    Hot Trending
                  </h4>
                  <div class="rtBlock d-flex align-items-center">
                    <a
                      class="d-flex align-items-center"
                      href="javascript:void(0)"
                      @click="categoryFlag = 0"
                    >
                      <feather class="mr-1" type="arrow-left"> Back</feather>
                    </a>
                    <div class="position-relative searchIcon ml-3">
                      <input
                        type="text"
                        placeholder="Search all Cryptos"
                        class="form-control small"
                        name=""
                      />
                      <a
                        href="javascript:void(0)"
                        class="l-1 inner position-absolute"
                        ><feather size="20px" type="search"></feather
                      ></a>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="marketData table-responsive innerScrollbar">
                    <table
                      class="table table-striped table-bordered textcolor"
                      width="100%"
                    >
                      <thead>
                        <tr>
                          <!-- <th class="pl-table">#</th> -->
                          <th>Name</th>
                          <th>Price</th>
                          <th>Change (24h)</th>
                          <th>Volume (24h)</th>
                          <th>$Price</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody v-if="Object.keys(top_screeners).length > 0">
                        <tr v-for="(spreads, index, keys) in top_screeners">
                          <td>
                            <span class="d-flex align-items-center themecolor">
                              <span class="inTableIcon mr-1 ml-0">
                                <img
                                  :src="
                                    '../../../../static/website/images/crypto_logos/' +
                                    spreads.i.split('-')[0].toLowerCase() +
                                    '.png'
                                  "
                                />
                              </span>
                              <div class="iqlName">
                                {{ spreads.i.split("-")[0] }}
                                <sup class="supUP f-10">{{
                                  spreads.i.split("-")[1]
                                }}</sup>
                              </div>
                            </span>
                          </td>
                          <td>{{ formatPrice(spreads.A, true) }}</td>
                          <td>
                            <span
                              class="d-flex align-items-center"
                              :class="spreads.CB > 0 ? 'green' : 'red'"
                            >
                              <feather
                                :type="
                                  spreads.CB > 0 ? 'chevron-up' : 'chevron-down'
                                "
                              ></feather>
                              {{ formatPrice(spreads.CB) }}%
                            </span>
                          </td>
                          <td>${{ formatPrice(spreads.VOLUME) }}</td>
                          <td>${{ formatPrice(spreads.priceInUsd) }}</td>
                          <td>
                            <a class="moreView" href="javascript:void(0)"
                              ><feather type="more-horizontal"></feather
                            ></a>
                          </td>
                        </tr>
                      </tbody>
                      <table-loader
                        :pageloader_value="pageLoader"
                        :type="'table'"
                        :colspan="'5'"
                        :listLength="Object.keys(top_screeners).length"
                        v-else
                      ></table-loader>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <news-list v-show="tabOpened == 'updates'" />
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import math from "../../../../static/website/js/math.js";
import { Const } from "@/plugins/vue-provider-cache/const.mod";
import tradingMixins from "@/plugins/trading";
import VueSlickCarousel from "vue-slick-carousel";
import newsList from "./news";

export default {
  name: "markets",
  mixins: [tradingMixins],
  data() {
    return {
      pageLoader: false,
      tabOpened: "marketfeed",
      mobtoggleButton: false,
      notification_msg: "",
      notification_type: "",
      filterCrypto: "",
      filterType: "ALL",
      page: "1",
      pageLimit: "10",
      errImage: [],
      fev_list: [],
      margin_list: {},
      settings: {
        dots: false,
        focusOnSelect: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        touchThreshold: 5,
      },
      categoryFlag: 0,
    };
  },
  watch: {
    tradingAccount(value) {
      this.getCurrency(value);
    },
  },
  methods: {
    openScreener() {
      this.tabOpened = "screener";
      let element = document.getElementById("tabs");
      element.scrollIntoView();
    },
    getCurrency(value) {
      if (value.length > 0 && value[0].subAccounts.length > 0) {
        this._runGetMarginInfo({
          globalParams: { account_id: this.tradingAccount[0].account_id },
          localParams: { parameter: this, page: "market" },
        });
      }
    },
    getCurrencyName(currency, first) {
      let arr = currency ? currency.split("-") : [];
      if (arr.length) {
        if (first) return arr[0];
        return arr[1];
      } else {
        return "";
      }
    },
    ExchangeEnableDisable(getCurrency) {
      let currency = getCurrency.split("-");
      let JsonData = { 0: "", 1: "" };
      for (let i = 0; i <= currency.length - 1; i++) {
        let sendReceive = 0,
          count = 0;
        for (let key in this.margin_list) {
          count++;
          if (
            this.margin_list[key].currency
              .toLowerCase()
              .includes(currency[i].toLowerCase())
          ) {
            sendReceive = 1;
          }

          if (
            count == Object.keys(this.margin_list).length &&
            sendReceive == 1 &&
            JsonData[0] == ""
          ) {
            JsonData[0] = currency[i];
          } else if (count == Object.keys(this.margin_list).length) {
            JsonData[1] = currency[i];
          }
        }

        if (i == currency.length - 1) {
          if (JsonData[0] != "") {
            return true;
          } else {
            return false;
          }
        }
      }
    },
    exchngeNowFunc(getCurrency) {
      let currency = getCurrency.split("-");
      let JsonData = { 0: "", 1: "" };
      for (let i = 0; i <= currency.length - 1; i++) {
        let sendReceive = 0,
          count = 0;
        for (let key in this.margin_list) {
          count++;
          if (
            this.margin_list[key].currency
              .toLowerCase()
              .includes(currency[i].toLowerCase())
          ) {
            sendReceive = 1;
          }

          if (
            count == Object.keys(this.margin_list).length &&
            sendReceive == 1 &&
            JsonData[0] == ""
          ) {
            JsonData[0] = currency[i];
          } else if (count == Object.keys(this.margin_list).length) {
            JsonData[1] = currency[i];
          }
        }

        if (i == currency.length - 1) {
          this.$router.replace({
            name: "smart_trading",
            params: { sendCurrency: JsonData[0], receiveCurrency: JsonData[1] },
          });
        }
      }
    },
    changeFilter(type) {
      this.filterType = type;
      this.filterCrypto = "";
      this.page = "1";
      this.mobtoggleButton = false;
    },
    addRemoveFev(currency) {
      if (this.fev_list.includes(currency)) {
        this.fev_list = this.fev_list.filter((item) => item !== currency);
      } else {
        this.fev_list.push(currency);
      }
      this._addfavoriteCurrencyList({
        globalParams: {
          currencies: this.fev_list,
          type: "isin",
        },
        localParams: { parameter: this },
      });
    },
    isImage(img) {
      return this.errImage.includes(img) ? false : true;
    },
    handleImgErr(val) {
      var fullSrc = val.target.src.split(".");
      var src = fullSrc[fullSrc.length - 2].split("/");
      var img = src[src.length - 1];
      if (!this.errImage.includes(img)) {
        this.errImage.push(img);
      }
    },
    formatfloat(num) {
      // return num
      num = parseFloat(num);
      try {
        return math.format(num, { notation: "fixed" }) || "";
      } catch (e) {
        try {
          return num.toFixed(8);
        } catch (e) {
          return "";
        }
      }
    },
    subscribe() {
      /*let subscribeArray = [];
      this.combinedCurrency.forEach((item, index) => {
        subscribeArray.push(item);
      });
      this.$store.getters[Const.GET_PROVIDERS]["priceFeed"].seeders[
        "S_PF_PF"
      ].subscribe(subscribeArray);*/
    },
    unSubscribe() {
      /*let subscribeArray = [];
      this.combinedCurrency.forEach((item, index) => {
        subscribeArray.push(item);
      });
      try{
        this.$store.getters[Const.GET_PROVIDERS]["priceFeed"].seeders["S_PF_PF"].unsubscribe(subscribeArray);
      }catch(e){}*/
    },
    dataList(value) {
      var data = Object.values(value);
      if (data.length > 0) {
        var _that = this;
        if (this.filterCrypto != "") {
          return data.filter((val) => {
            return (
              val.other.isinid
                .toLowerCase()
                .includes(_that.filterCrypto.trim().toLowerCase()) ||
              val.other.Description.toLowerCase().includes(
                _that.filterCrypto.trim().toLowerCase()
              )
            );
          });
        } else if (this.filterType == "ALL") {
          return data;
        } else if (this.filterType == "Favorites") {
          return data.filter((val) => this.fev_list.includes(val.other.isinid));
        } else if (this.filterType != "ALL" && this.filterType != "Favorites") {
          return data.filter((val) => {
            return val.other.isinid
              .toLowerCase()
              .split("-")
              .includes(_that.filterType.toLowerCase());
          });
        } else {
          return data;
        }
      } else {
        return [];
      }
    },
  },
  components: { VueSlickCarousel, newsList },
  computed: {
    top_categories() {
      try {
        // just 'feel' the pulse here so we get a reactive response
        // as the cache is not reactive
        this.$store.getters[Const.GET_HEARTBEATS]["priceFeed"];
        return this.$store.getters[Const.GET_PROVIDERS][
          "priceFeed"
        ].iCache.getHotTredning();
      } catch (ex) {
        // console.log('OO-one [ex]', ex)
        return [];
      }
    },

    top_screeners() {
      try {
        this.$store.getters[Const.GET_HEARTBEATS]["priceFeed"];
        if (this.categoryFlag == 1) {
          let gainers =
            this.$store.getters[Const.GET_PROVIDERS][
              "priceFeed"
            ].iCache.getTopGainerNew();
          return Object.entries(gainers)
            .sort(([, a], [, b]) => b.CB - a.CB)
            .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
        } else if (this.categoryFlag == 2) {
          let loosers =
            this.$store.getters[Const.GET_PROVIDERS][
              "priceFeed"
            ].iCache.getTopLooserNew();
          return Object.entries(loosers)
            .sort(([, a], [, b]) => a.CB - b.CB)
            .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
        } else if (this.categoryFlag == 3) {
          let traded =
            this.$store.getters[Const.GET_PROVIDERS][
              "priceFeed"
            ].iCache.getMostTraded();
          return Object.entries(traded)
            .sort(([, a], [, b]) => b.VOLUME - a.VOLUME)
            .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
        } else if (this.categoryFlag == 4) {
          return this.$store.getters[Const.GET_PROVIDERS][
            "priceFeed"
          ].iCache.getHotTredning();
        } else {
          return {};
        }
      } catch (ex) {
        console.log("OO-one [ex]", ex);
        return {};
      }
    },

    get_currencies() {
      try {
        // just 'feel' the pulse here so we get a reactive response
        // as the cache is not reactive
        this.$store.getters[Const.GET_HEARTBEATS]["priceFeed"];
        return this.$store.getters[Const.GET_PROVIDERS][
          "priceFeed"
        ].iCache.asKeysValueArrayAll();
      } catch (ex) {
        // console.log('OO-one [ex]', ex)
        return [];
      }
    },
  },
  created() {
    this.pageName("Markets");
    if (this.$route.query.filterType) {
      this.changeFilter(this.$route.query.filterType);
    }
    this._runCryptoList({
      globalParams: {},
      localParams: { parameter: this, page: "market" },
    });
    this._getfavoriteCurrencyList({
      globalParams: { type: "isin" },
      localParams: { parameter: this },
    });
    this.getCurrency(this.tradingAccount);
  },
  /*beforeDestroy() {
    this.unSubscribe();
  },*/
};
</script>



// WEBPACK FOOTER //
// src/components/website/markets/markets.vue